import { gql } from '@apollo/client';

export const REVERT_CASH_TRANSACTION = gql`
	mutation Revert_cash_transaction($invoice_id: ID!) {
		revert_cash_transaction(invoice_id: $invoice_id) {
			_id
			createdAt
			fee_breakup
			invoice_pdf_link
			status
		}
	}
`;

export const GET_TRANSACTIONS = gql`
	query GetTransactionReport(
		$school_id: String!
		$endDate: String
		$gateway: [String!]
		$isCollectNow: Boolean
		$isCustomSearch: Boolean
		$isQRCode: Boolean
		$limit: String
		$page: String
		$payment_modes: [String!]
		$searchFilter: String
		$searchParams: String
		$startDate: String
		$status: String
		$trustee_id: String
	) {
		getTransactionReport(
			school_id: $school_id
			endDate: $endDate
			gateway: $gateway
			isCollectNow: $isCollectNow
			isCustomSearch: $isCustomSearch
			isQRCode: $isQRCode
			limit: $limit
			page: $page
			payment_modes: $payment_modes
			searchFilter: $searchFilter
			searchParams: $searchParams
			startDate: $startDate
			status: $status
			trustee_id: $trustee_id
		) {
			current_page
			total_pages
			transactionReport {
				bank_reference
				capture_status
				class_name
				collect_id
				commission
				createdAt
				currency
				custom_order_id
				details
				gateway
				isAutoRefund
				isCollectNow
				isQRPayment
				isVBAPaymentComplete
				order_amount
				payment_id
				payment_method
				payment_time
				reason
				remarks
				school_id
				school_name
				settlement_transfer_time
				status
				student_email
				student_id
				student_name
				student_phone
				student_receipt
				transaction_amount
				updatedAt
				utr_number
				virtual_account_id
				virtual_account_ifsc
				virtual_account_number
				error_details {
					error_description
					error_reason
					error_source
				}
				vendors_info {
					amount
					edv_vendor_id
					name
					percentage
					vendor_id
				}
			}
		}
	}
`;
